import {GridAlgorithm, MarkerClusterer, Renderer} from "@googlemaps/markerclusterer";

export default function storeLocator() {
    initAutocomplete();
    initMap();

    function initAutocomplete() {
        const form = document.querySelector(".store-locator__form");
        const input = document.querySelector(`input[name="location"]`) as any;

        if (form && input) {
            let options = {
                types: ["(regions)"],
                componentRestrictions: {country: "fr"},
            };

            const searchBox = new google.maps.places.SearchBox(input);

            // Listen for the event fired when the user selects an item from the
            // pick list. Retrieve the matching places for that item.
            google.maps.event.addListener(
                searchBox,
                "places_changed",
                function () {
                    // @ts-ignore
                    var place = searchBox.getPlaces()[0];

                    if (!place.geometry) return;

                    if (place.geometry.location) {
                        const coordinates_input = document.querySelector(
                            `input[name="coordinates"]`
                        ) as any;
                        coordinates_input.setAttribute(
                            "value",
                            place.geometry.location.lat() +
                            "," +
                            place.geometry.location.lng()
                        );
                    }

                    if (place.address_components) {
                        let city = {} as any;
                        for (
                            let i = 0;
                            i < place.address_components.length;
                            i++
                        ) {
                            if (
                                place.address_components[i].types[0] ==
                                "locality"
                            ) {
                                city = place.address_components[i];
                            }
                        }

                        // Set city in location input.
                        if (city.long_name) {
                            const location_input = document.querySelector(
                                `input[name="location"]`
                            ) as any;
                            location_input.setAttribute(
                                "value",
                                city.long_name
                            );
                        }
                    }
                }
            );

            if (form instanceof HTMLFormElement) {
                form.onsubmit = (e) => {
                    e.preventDefault();

                    const target = e.target as HTMLFormElement;
                    if (target) {
                        setTimeout(() => {
                            target.submit();
                        }, 1000);
                    }
                };
            }
        }
    }

    /*
     * Init map.
     */
    async function initMap() {
        // Create map.
        const map = createMap();

        const siteList = window.drupalSettings.siteList;
        if (siteList.length > 0) {
            const markers = [] as any;
            const bounds = new google.maps.LatLngBounds();
            siteList.forEach((site: any) => {
                // Create markers.
                createMarker(site, map, markers, bounds);
            });

            // Add MarkerClusterer.
            createMarkerClusterer({map, markers});

            // Click event listeners to geolocate user.
            const locate_me = document.querySelector(
                `button.locate-me`
            ) as HTMLElement;
            locate_me.addEventListener("click", function () {
                geolocate();
            });

            // Click on map filters.
            const map_filter = document.querySelectorAll(
                `input[name="map-filter"]`
            ) as NodeListOf<Element>;
            for (const filter of map_filter as any) {
                filter.addEventListener("click", function () {
                    filterLegendMap(map_filter, markers, map);
                });
            }
        }

        const locationInput = window.drupalSettings.locationInput as any | null;
        const coordinatesInput = window.drupalSettings.coordinatesInput as
            | any
            | null;

        if (locationInput) {
            let input = document.querySelector(
                'input[name="location"]'
            ) as HTMLElement;
            input.setAttribute("value", locationInput);

            // Zoom on the map if there is a search by location.
            const locationLatLng = window.drupalSettings.locationLatLng as
                | any
                | null;
            if (locationLatLng != null) {
                map.setCenter(
                    new google.maps.LatLng({
                        lat: Number(locationLatLng[0]),
                        lng: Number(locationLatLng[1]),
                    })
                );
                map.setZoom(8);
            }

            if (coordinatesInput) {
                let input_test = document.querySelector(
                    'input[name="coordinates"]'
                ) as HTMLElement;
                input_test.setAttribute("value", coordinatesInput);
            }
        }

        /*
         * Create map.
         */
        function createMap() {
            // Create an array of styles.
            const mapStyles = [
                {
                    featureType: "administrative",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#1E1E1E",
                        },
                    ],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.fill",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            color: "#E4E5E5",
                        },
                    ],
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#828282",
                        },
                        {
                            lightness: "36",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 45,
                        },
                    ],
                },

                {
                    featureType: "water",
                    elementType: "all",
                    stylers: [
                        {
                            color: "#C3C4C6",
                        },
                        {
                            visibility: "on",
                        },
                    ],
                },
                {featureType: "poi", stylers: [{visibility: "off"}]},
                {featureType: "transit", stylers: [{visibility: "off"}]},
            ];

            const center: google.maps.LatLngLiteral = {
                lat: 46.71109,
                lng: 1.7191036,
            };
            const mapOptions = {
                center,
                zoom: 6,
                styles: mapStyles,
                mapTypeControl: false,
            };

            return new google.maps.Map(
                document.getElementById("store-locator-map") as HTMLElement,
                mapOptions
            );
        }

        /*
         * Create marker.
         */
        function createMarker(site: any, map: any, markers: any, bounds: any) {
            const types = ['Salle expo', 'Siège social', 'Agence'];

            if (site.coordonnees_gps && types.includes(site.type_site)) {
                const coordinates = site.coordonnees_gps.split(",");
                const lat = Number(coordinates[0]);
                const lng = Number(coordinates[1]);
                const position = {lat: lat, lng: lng};

                // Paramètre de icons
                let svg = "";
                if (site.type_site == "Salle expo") {
                    svg = window.btoa(`
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 13.3333C24 18 16 26.6666 16 26.6666C16 26.6666 8 18 8 13.3333C8 8.91665 11.5833 5.33331 16 5.33331C20.4167 5.33331 24 8.91665 24 13.3333Z" fill="#D67F1C"/>
                    <path d="M19.8322 13.0416C19.4479 13.0416 19.0949 12.9147 18.8106 12.7057C18.7165 12.6373 18.6321 12.5612 18.5557 12.4752C18.4792 12.5592 18.3949 12.6354 18.3027 12.7037C18.0184 12.9147 17.6634 13.0416 17.2771 13.0416C16.8928 13.0416 16.5418 12.9166 16.2575 12.692C16.1633 12.6393 16.0771 12.5612 15.9986 12.4752C15.9202 12.5612 15.8339 12.6393 15.7398 12.692C15.4554 12.9166 15.1044 13.0416 14.7201 13.0416C14.3377 13.0416 13.9848 12.9166 13.7004 12.692C13.6063 12.6393 13.52 12.5612 13.4435 12.4752C13.3651 12.5612 13.2769 12.6393 13.1827 12.692C12.9004 12.9166 12.5317 13.024 12.1652 13.0416H12.1642C12.0846 13.0416 12.0044 13.0358 11.9266 13.026C10.8418 12.8815 10.3285 11.608 10.9087 10.694L12.0329 8.92307C12.1329 8.76387 12.3115 8.66663 12.5023 8.66663H19.4989C19.6891 8.66663 19.8675 8.76385 19.9675 8.92307L21.0911 10.694C21.6735 11.61 21.1578 12.8815 20.0695 13.026C19.993 13.0358 19.9146 13.024 19.8342 13.0416C19.8342 13.0416 19.8342 13.0416 19.8322 13.0416ZM19.2871 9.60413H12.7141L11.7044 11.1959C11.5909 11.3737 11.5801 11.5944 11.6601 11.7838C11.7369 11.9635 11.8762 12.0729 12.0505 12.0963C12.0899 12.1022 12.1285 12.1041 12.1642 12.1041C12.3964 12.1041 12.6003 12.0045 12.7435 11.8463C12.9219 11.651 13.1592 11.5377 13.4435 11.5377C13.7083 11.5377 13.9632 11.651 14.1416 11.8463C14.2848 12.0045 14.4887 12.1041 14.7201 12.1041C14.9534 12.1041 15.1397 12.0045 15.3005 11.8463C15.479 11.651 15.7319 11.5377 15.9986 11.5377C16.2653 11.5377 16.5183 11.651 16.6967 11.8463C16.8399 12.0045 17.0458 12.1041 17.2771 12.1041C17.5085 12.1041 17.7125 12.0045 17.8556 11.8463C18.0341 11.651 18.287 11.5377 18.5537 11.5377C18.8184 11.5377 19.0733 11.649 19.2518 11.8463C19.3969 12.0045 19.6028 12.1041 19.8322 12.1041C19.8714 12.1041 19.9087 12.1022 19.9479 12.0963C20.1244 12.0729 20.2636 11.9635 20.3401 11.7838C20.4205 11.5787 20.4107 11.3756 20.297 11.1959L19.2871 9.60413ZM19.4518 15.2291V13.6354C19.5753 13.6569 19.7028 13.6666 19.8322 13.6666C19.942 13.6666 20.0479 13.6588 20.1518 13.6451C20.2185 13.6354 20.3146 13.6198 20.393 13.6002V17.4166C20.393 18.1061 19.8303 18.6666 19.1381 18.6666H12.8631C12.1701 18.6666 11.6081 18.1061 11.6081 17.4166V13.6002C11.684 13.6198 11.7622 13.6354 11.8428 13.6451H11.8452C11.9483 13.6588 12.0558 13.6666 12.1642 13.6666C12.2956 13.6666 12.4239 13.6549 12.5494 13.6354V15.2291H19.4518ZM19.4518 16.1666H12.5494V17.4166C12.5494 17.5885 12.6905 17.7291 12.8631 17.7291H19.1381C19.3106 17.7291 19.4518 17.5885 19.4518 17.4166V16.1666Z" fill="white"/>
                    </svg>`);
                } else if (site.type_site == "Agence") {
                    svg = window.btoa(`
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 13.3333C24 18 16 26.6666 16 26.6666C16 26.6666 8 18 8 13.3333C8 8.91665 11.5833 5.33331 16 5.33331C20.4167 5.33331 24 8.91665 24 13.3333Z" fill="#C7352D"/>
                    <path d="M21.1763 12.8539C21.3634 13.0106 21.3874 13.2859 21.2282 13.47C21.0689 13.6541 20.7893 13.6778 20.6022 13.5211L20.1485 13.1419V16.5416C20.1485 17.3474 19.4856 18 18.667 18H13.3337C12.5155 18 11.8522 17.3474 11.8522 16.5416V13.1419L11.399 13.5211C11.2118 13.6778 10.9314 13.6541 10.7725 13.47C10.6138 13.2859 10.6367 13.0106 10.8239 12.8539L15.7133 8.77053C15.8781 8.63199 16.1226 8.63199 16.2874 8.77053L21.1763 12.8539ZM13.3337 17.125H14.2226V14.3541C14.2226 13.9513 14.5541 13.625 14.9633 13.625H17.0374C17.4467 13.625 17.7781 13.9513 17.7781 14.3541V17.125H18.667C18.9948 17.125 19.2596 16.8643 19.2596 16.5416V12.4L16.0004 9.6778L12.7411 12.4V16.5416C12.7411 16.8643 13.0059 17.125 13.3337 17.125ZM15.1115 17.125H16.8893V14.5H15.1115V17.125Z" fill="white"/>
                    </svg>`);
                } else {
                    svg = window.btoa(`
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 13.3333C24 18 16 26.6666 16 26.6666C16 26.6666 8 18 8 13.3333C8 8.91665 11.5833 5.33331 16 5.33331C20.4167 5.33331 24 8.91665 24 13.3333Z" fill="#003160"/>
                    <path d="M19.3833 13.6228C19.4846 13.9419 19.5715 14.2658 19.6438 14.5849C20.295 14.0482 20.8497 13.4584 21.2983 12.8299C21.5057 11.4955 20.787 10.1466 19.4846 9.60513L16.1563 8.22723C15.9634 8.14504 15.7656 8.08703 15.5678 8.05318C17.2079 9.25219 18.6164 11.2054 19.3833 13.6276V13.6228Z" fill="white"/>
                    <path d="M16.3059 9.93389C16.6242 9.83236 16.9474 9.74533 17.2658 9.67281C16.7448 9.03947 16.1756 8.49798 15.5727 8.05318C15.3846 8.0145 15.2013 8 15.018 8C13.8458 8 12.7315 8.6962 12.254 9.8517L10.8937 13.1538C10.8069 13.3665 10.7442 13.5889 10.7056 13.8065C11.9019 12.1385 13.8651 10.7074 16.3059 9.93389Z" fill="white"/>
                    <path d="M12.6206 13.0184C12.5193 12.6994 12.4324 12.3754 12.3601 12.0563C11.7137 12.593 11.1542 13.1828 10.7056 13.8065C10.6815 13.9709 10.667 14.1353 10.667 14.2948C10.667 15.4745 11.3664 16.5865 12.5145 17.0603L15.8476 18.4382C16.0598 18.5252 16.2769 18.588 16.4988 18.6267C14.8298 17.4325 13.402 15.46 12.6254 13.0136L12.6206 13.0184Z" fill="white"/>
                    <path d="M19.7451 16.8185L21.1054 13.5164C21.197 13.2892 21.2597 13.062 21.2983 12.8299C20.1069 14.4979 18.1388 15.9289 15.7029 16.7073C15.3845 16.8089 15.0613 16.8959 14.743 16.9684C15.2784 17.6211 15.8717 18.1819 16.494 18.6267C17.8349 18.8491 19.2049 18.1287 19.7451 16.8185Z" fill="white"/>
                    </svg>`);
                }
                let markerIcon = {
                    url: `data:image/svg+xml;base64,${svg}`,
                    scaledSize: new google.maps.Size(42, 42),
                    origin: new google.maps.Point(0, 0),
                };

                // Create marker.
                let marker = new google.maps.Marker({
                    map: map,
                    position: new google.maps.LatLng(position),
                    icon: markerIcon,
                });

                // Set type_site.
                marker.set("typeSite", site.type_site);

                // Set coop_id.
                marker.set("id", site.coop_id);

                // Click on marker.
                marker.addListener("click", function () {
                    map.setZoom(9);
                    map.setCenter(marker.getPosition());

                    // Disabled the scroll in the list if the site exists in several times.
                    const same_sites = document.querySelectorAll(
                        `[data-site-id="${site.site_id}"]`
                    ) as NodeListOf<Element>;

                    if (same_sites.length === 1) {
                        // Scroll until the coop.
                        const coop = document.querySelector(
                            `[data-coop-id="${site.coop_id}"]`
                        ) as HTMLElement;

                        const storeLocatorElement = document.querySelector(
                            ".store-locator"
                        ) as HTMLElement;

                        // coop.scrollIntoView({
                        //     behavior: "smooth",
                        //     block: "start",
                        //     inline: "start",
                        // });

                        if (storeLocatorElement) {
                            document.documentElement.scrollTop =
                                storeLocatorElement.offsetTop - 80;
                        }

                        if (coop && coop.parentNode) {
                            (coop.parentNode as HTMLElement).scrollTop =
                                coop.offsetTop -
                                (coop.parentNode as HTMLElement).offsetTop;
                        }
                    }
                });

                // Click button localisation on the coops list.
                setTimeout(() => {
                    let coop = document.querySelector(
                        `[data-coop-id="${site.coop_id}"] button`
                    ) as HTMLElement;
                    if (coop) {
                        coop.addEventListener("click", () => {
                            highlightCoopSites(site, markers, map);
                        });
                    }
                }, 1000);

                // All markers.
                bounds.extend(position);
                markers.push(marker);
            }
        }

        /*
         * Geolocate.
         */
        function geolocate() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    let pos = (position.coords.latitude +
                        "," +
                        position.coords.longitude) as string;

                    // Add city in location input.
                    let geocoder = new google.maps.Geocoder();
                    geocoder.geocode(
                        {address: pos},
                        function (results, status) {
                            if (status == google.maps.GeocoderStatus.OK) {
                                let city: any = {
                                    long_name: undefined,
                                };

                                let geometry: any = "";

                                if (results) {
                                    let resultsNumber =
                                        results.length as number;
                                    let indice = 0;
                                    for (let j = 0; j < resultsNumber; j++) {
                                        if (results[j].types[0] == "locality") {
                                            indice = j;
                                            break;
                                        }
                                    }
                                    for (
                                        let i = 0;
                                        i <
                                        results[indice].address_components
                                            .length;
                                        i++
                                    ) {
                                        if (
                                            results[indice].address_components[
                                                i
                                                ].types[0] == "locality"
                                        ) {
                                            city =
                                                results[indice]
                                                    .address_components[i];

                                            geometry = results[indice].geometry;
                                        }
                                    }

                                    // set city in location input.
                                    const location_input =
                                        document.querySelector(
                                            `input[name="location"]`
                                        ) as any;
                                    location_input.setAttribute(
                                        "value",
                                        city.long_name
                                    );

                                    const coordinates_input =
                                        document.querySelector(
                                            `input[name="coordinates"]`
                                        ) as any;
                                    coordinates_input.setAttribute(
                                        "value",
                                        geometry.location.lat() +
                                        "," +
                                        geometry.location.lng()
                                    );
                                } else {
                                    console.log("No results found");
                                }
                            } else {
                                console.log(
                                    "Geocoder failed due to: " + status
                                );
                            }
                        }
                    );
                });
            }
        }

        /*
         * Highlight coop and site on the map.
         */
        function highlightCoopSites(site: any, markers: any, map: any) {
            markers.forEach((marker: any) => {
                let svg = "";
                if (marker.typeSite == "Salle expo") {
                    let color =
                        marker.id == site.coop_id ? "#D67F1C" : "#F2D2AE";
                    svg = window.btoa(`
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 13.3333C24 18 16 26.6666 16 26.6666C16 26.6666 8 18 8 13.3333C8 8.91665 11.5833 5.33331 16 5.33331C20.4167 5.33331 24 8.91665 24 13.3333Z" fill="${color}"/>
                    <path d="M19.8322 13.0416C19.4479 13.0416 19.0949 12.9147 18.8106 12.7057C18.7165 12.6373 18.6321 12.5612 18.5557 12.4752C18.4792 12.5592 18.3949 12.6354 18.3027 12.7037C18.0184 12.9147 17.6634 13.0416 17.2771 13.0416C16.8928 13.0416 16.5418 12.9166 16.2575 12.692C16.1633 12.6393 16.0771 12.5612 15.9986 12.4752C15.9202 12.5612 15.8339 12.6393 15.7398 12.692C15.4554 12.9166 15.1044 13.0416 14.7201 13.0416C14.3377 13.0416 13.9848 12.9166 13.7004 12.692C13.6063 12.6393 13.52 12.5612 13.4435 12.4752C13.3651 12.5612 13.2769 12.6393 13.1827 12.692C12.9004 12.9166 12.5317 13.024 12.1652 13.0416H12.1642C12.0846 13.0416 12.0044 13.0358 11.9266 13.026C10.8418 12.8815 10.3285 11.608 10.9087 10.694L12.0329 8.92307C12.1329 8.76387 12.3115 8.66663 12.5023 8.66663H19.4989C19.6891 8.66663 19.8675 8.76385 19.9675 8.92307L21.0911 10.694C21.6735 11.61 21.1578 12.8815 20.0695 13.026C19.993 13.0358 19.9146 13.024 19.8342 13.0416C19.8342 13.0416 19.8342 13.0416 19.8322 13.0416ZM19.2871 9.60413H12.7141L11.7044 11.1959C11.5909 11.3737 11.5801 11.5944 11.6601 11.7838C11.7369 11.9635 11.8762 12.0729 12.0505 12.0963C12.0899 12.1022 12.1285 12.1041 12.1642 12.1041C12.3964 12.1041 12.6003 12.0045 12.7435 11.8463C12.9219 11.651 13.1592 11.5377 13.4435 11.5377C13.7083 11.5377 13.9632 11.651 14.1416 11.8463C14.2848 12.0045 14.4887 12.1041 14.7201 12.1041C14.9534 12.1041 15.1397 12.0045 15.3005 11.8463C15.479 11.651 15.7319 11.5377 15.9986 11.5377C16.2653 11.5377 16.5183 11.651 16.6967 11.8463C16.8399 12.0045 17.0458 12.1041 17.2771 12.1041C17.5085 12.1041 17.7125 12.0045 17.8556 11.8463C18.0341 11.651 18.287 11.5377 18.5537 11.5377C18.8184 11.5377 19.0733 11.649 19.2518 11.8463C19.3969 12.0045 19.6028 12.1041 19.8322 12.1041C19.8714 12.1041 19.9087 12.1022 19.9479 12.0963C20.1244 12.0729 20.2636 11.9635 20.3401 11.7838C20.4205 11.5787 20.4107 11.3756 20.297 11.1959L19.2871 9.60413ZM19.4518 15.2291V13.6354C19.5753 13.6569 19.7028 13.6666 19.8322 13.6666C19.942 13.6666 20.0479 13.6588 20.1518 13.6451C20.2185 13.6354 20.3146 13.6198 20.393 13.6002V17.4166C20.393 18.1061 19.8303 18.6666 19.1381 18.6666H12.8631C12.1701 18.6666 11.6081 18.1061 11.6081 17.4166V13.6002C11.684 13.6198 11.7622 13.6354 11.8428 13.6451H11.8452C11.9483 13.6588 12.0558 13.6666 12.1642 13.6666C12.2956 13.6666 12.4239 13.6549 12.5494 13.6354V15.2291H19.4518ZM19.4518 16.1666H12.5494V17.4166C12.5494 17.5885 12.6905 17.7291 12.8631 17.7291H19.1381C19.3106 17.7291 19.4518 17.5885 19.4518 17.4166V16.1666Z" fill="white"/>
                    </svg>`);
                } else if (marker.typeSite == "Agence") {
                    let color =
                        marker.id == site.coop_id ? "#C7352D" : "#EFBCB9";
                    svg = window.btoa(`
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24 13.3333C24 18 16 26.6666 16 26.6666C16 26.6666 8 18 8 13.3333C8 8.91665 11.5833 5.33331 16 5.33331C20.4167 5.33331 24 8.91665 24 13.3333Z" fill="${color}"/>
                            <path d="M21.1763 12.8539C21.3634 13.0106 21.3874 13.2859 21.2282 13.47C21.0689 13.6541 20.7893 13.6778 20.6022 13.5211L20.1485 13.1419V16.5416C20.1485 17.3474 19.4856 18 18.667 18H13.3337C12.5155 18 11.8522 17.3474 11.8522 16.5416V13.1419L11.399 13.5211C11.2118 13.6778 10.9314 13.6541 10.7725 13.47C10.6138 13.2859 10.6367 13.0106 10.8239 12.8539L15.7133 8.77053C15.8781 8.63199 16.1226 8.63199 16.2874 8.77053L21.1763 12.8539ZM13.3337 17.125H14.2226V14.3541C14.2226 13.9513 14.5541 13.625 14.9633 13.625H17.0374C17.4467 13.625 17.7781 13.9513 17.7781 14.3541V17.125H18.667C18.9948 17.125 19.2596 16.8643 19.2596 16.5416V12.4L16.0004 9.6778L12.7411 12.4V16.5416C12.7411 16.8643 13.0059 17.125 13.3337 17.125ZM15.1115 17.125H16.8893V14.5H15.1115V17.125Z" fill="white"/>
                            </svg>`);
                } else if (marker.typeSite == "Siège social") {
                    let color =
                        marker.id == site.coop_id ? "#003160" : "#C0D5EA";
                    svg = window.btoa(`
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24 13.3333C24 18 16 26.6666 16 26.6666C16 26.6666 8 18 8 13.3333C8 8.91665 11.5833 5.33331 16 5.33331C20.4167 5.33331 24 8.91665 24 13.3333Z" fill="${color}"/>
                            <path d="M19.3833 13.6228C19.4846 13.9419 19.5715 14.2658 19.6438 14.5849C20.295 14.0482 20.8497 13.4584 21.2983 12.8299C21.5057 11.4955 20.787 10.1466 19.4846 9.60513L16.1563 8.22723C15.9634 8.14504 15.7656 8.08703 15.5678 8.05318C17.2079 9.25219 18.6164 11.2054 19.3833 13.6276V13.6228Z" fill="white"/>
                            <path d="M16.3059 9.93389C16.6242 9.83236 16.9474 9.74533 17.2658 9.67281C16.7448 9.03947 16.1756 8.49798 15.5727 8.05318C15.3846 8.0145 15.2013 8 15.018 8C13.8458 8 12.7315 8.6962 12.254 9.8517L10.8937 13.1538C10.8069 13.3665 10.7442 13.5889 10.7056 13.8065C11.9019 12.1385 13.8651 10.7074 16.3059 9.93389Z" fill="white"/>
                            <path d="M12.6206 13.0184C12.5193 12.6994 12.4324 12.3754 12.3601 12.0563C11.7137 12.593 11.1542 13.1828 10.7056 13.8065C10.6815 13.9709 10.667 14.1353 10.667 14.2948C10.667 15.4745 11.3664 16.5865 12.5145 17.0603L15.8476 18.4382C16.0598 18.5252 16.2769 18.588 16.4988 18.6267C14.8298 17.4325 13.402 15.46 12.6254 13.0136L12.6206 13.0184Z" fill="white"/>
                            <path d="M19.7451 16.8185L21.1054 13.5164C21.197 13.2892 21.2597 13.062 21.2983 12.8299C20.1069 14.4979 18.1388 15.9289 15.7029 16.7073C15.3845 16.8089 15.0613 16.8959 14.743 16.9684C15.2784 17.6211 15.8717 18.1819 16.494 18.6267C17.8349 18.8491 19.2049 18.1287 19.7451 16.8185Z" fill="white"/>
                            </svg>`);
                }
                let markerIcon = {
                    url: `data:image/svg+xml;base64,${svg}`,
                    scaledSize: new google.maps.Size(42, 42),
                    origin: new google.maps.Point(0, 0),
                };
                marker.setIcon(markerIcon);

                if (marker.id == site.coop_id) {
                    marker.setZIndex(100);
                }

                marker.setMap(map);

                if (
                    marker.typeSite == "Siège social" &&
                    marker.id == site.coop_id
                ) {
                    map.setZoom(9);
                    map.setCenter(marker.getPosition());
                }
            });
        }

        /*
         * Filter on the map.
         */
        function filterLegendMap(map_filter: any, markers: any, map: any) {
            let checkCoops = [] as any;
            let typesSite = {
                siege: "Siège social",
                "salle-expo": "Salle expo",
                agence: "Agence",
            } as any;
            for (let i = 0; i < map_filter.length; i++) {
                if (map_filter[i].checked) {
                    let id = map_filter[i].id as any;
                    checkCoops.push(typesSite[id] as string);
                }
            }
            markers.forEach((marker: any) => {
                let marker_type_site = marker.typeSite as any;
                if (checkCoops.includes(marker_type_site)) {
                    marker.setMap(map);
                } else {
                    marker.setMap(null);
                }
            });
        }
    }

    /*
 * Create MarkerClusterer.
 */
    function createMarkerClusterer({map, markers}: {
        map: google.maps.Map,
        markers: any
    }) {
        const svg = window.btoa(`
                    <svg width="250" height="250" viewBox="0 0 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="250" height="250" rx="125" fill="white"/>
                    </svg>`);

        // Render MarkerClusterer.
        const renderer = {
            render: ({count, position}: { count: number, position: any }) =>
                new google.maps.Marker({
                    label: {
                        text: String(count),
                        color: "#003160",
                        fontSize: "18px",
                        fontWeight: "700",
                    },
                    icon: {
                        url: `data:image/svg+xml;base64,${svg}`,
                        scaledSize: new google.maps.Size(50, 50),
                    },
                    position,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                }),
        };

        // Param MarkerClusterer zone.
        const algorithm = new GridAlgorithm({
            gridSize: 55,
        });

        // Click on the cluster.
        const onClusterClick = function (_event: any, cluster: any, map: any) {
            if (cluster.markers.length > 2) {
                map.setZoom(map.getZoom() + 1);
            } else if (cluster.markers.length == 2) {
                let latlngbounds = new google.maps.LatLngBounds();
                cluster.markers.forEach((marker: any) => {
                    latlngbounds.extend(marker.position);
                });
                map.setCenter(latlngbounds.getCenter());
                map.fitBounds(latlngbounds);
            } else {
                map.setZoom(14);
            }

            map.setCenter({
                lat: cluster.position.lat(),
                lng: cluster.position.lng(),
            });
        };

        new MarkerClusterer({
            map,
            markers,
            algorithm,
            renderer,
            onClusterClick,
        });
    }
}
